import { render } from "./NavMainItem.vue?vue&type=template&id=63d5265e&scoped=true&ts=true"
import script from "./NavMainItem.vue?vue&type=script&lang=ts"
export * from "./NavMainItem.vue?vue&type=script&lang=ts"

import "./NavMainItem.vue?vue&type=style&index=0&id=63d5265e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d5265e"]])

export default __exports__